import React, { Fragment } from 'react';

import { FormFlex, FormBox, FormGroupLoader, FormLegendLoader } from 'components/shared/form';

function Loader() {
  return (
    <Fragment>
      <FormFlex>
        <FormBox width={1}>
          <FormLegendLoader mb="1rem" width="10.625rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="9.375rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="4.375rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="4.375rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="1.75rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="6.5rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="5rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="6rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="6rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="1.75rem" />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

export default Loader;
